import cx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useEnv } from '#admin/hook/useEnv.tsx';
import type { RootState } from '#admin/store.ts';

export const Footer = () => {
  const token = useSelector((state: RootState) => state.app.token);
  const isAuthenticated = !!token;
  const { t } = useTranslation();
  const env = useEnv();

  const getDocumentUrl = (docType: string) => {
    return `${env.LEGAL_DOCS_URL}/${docType}.pdf`;
  };

  return (
    <footer className={cx('fixed right-0 bottom-0 left-0 z-50 px-4 py-2', isAuthenticated && 'bg-blue-light')}>
      <div className={cx('flex flex-row justify-end gap-4', !isAuthenticated ? 'text-white' : 'text-grey-label')}>
        <a href={getDocumentUrl('terms-and-conditions')} target="_blank" rel="noopener noreferrer">
          {t('labels.termsAndConditions')}
        </a>
        <a href={getDocumentUrl('privacy-policy')} target="_blank" rel="noopener noreferrer">
          {t('labels.privacyPolicy')}
        </a>
        <a href={getDocumentUrl('cookie-policy')} target="_blank" rel="noopener noreferrer">
          {t('labels.cookiePolicy')}
        </a>
      </div>
    </footer>
  );
};
